export const WEBSITE_BUILD_STARTED_EVENT = "WEBSITE_BUILD_STARTED";
export const WEBSITE_PREVIEW_READY_EVENT = "WEBSITE_PREVIEW_READY";
export const WEBSITE_BUILD_SUCCEEDED_EVENT = "WEBSITE_BUILD_SUCCEEDED";
export const WEBSITE_BUILD_FAILED_EVENT = "WEBSITE_BUILD_FAILED";
export const WEBSITE_BUILD_FLOW_STARTED_EVENT = "WEBSITE_BUILD_FLOW_STARTED";
export const WEBSITE_BUILD_FLOW_ABANDONED_EVENT = "WEBSITE_BUILD_FLOW_ABANDONED";
export const WEBSITE_SITE_LCP_RECORDED_EVENT = "SITE_LCP_RECORDED";

export const WEBSITE_ANALYTICS_SURFACE_PREVIEW = "preview";
export const WEBSITE_ANALYTICS_SURFACE_LIVE = "live";
export const WEBSITE_ANALYTICS_VIEWPORT_MOBILE = "mobile";
export const WEBSITE_ANALYTICS_VIEWPORT_TABLET = "tablet";
export const WEBSITE_ANALYTICS_VIEWPORT_DESKTOP = "desktop";
